'use client';
import { useState } from 'react';
import Map from 'shared/sections/Map';

import ContactsMain from '~/components/features/contacts/ContactsMain';

export default function ContactsWrapper() {
    const [showMap, setShowMap] = useState(false);
    const [currentCity, setCurrentCity] = useState<'moscow' | 'rostov'>('moscow');

    const openMap = () => {
        setShowMap(true);
    };

    const closeMap = () => {
        setShowMap(false);
    };

    return (
        <>
            <ContactsMain
                showMap={showMap}
                openMap={openMap}
                closeMap={closeMap}
                currentCity={currentCity}
                setCurrentCity={setCurrentCity}
            />
            <Map showMap={showMap} currentCity={currentCity} />
        </>
    );
}
